import Layout from './default'

export default Layout
